import * as React from 'react'

export function PresetsEnergize(props) {
  return (
    <svg viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M25.998 15.956c0 5.527-4.515 10.018-10.042 10.042-4.372-.02-8.083-2.861-9.42-6.792l7.727-4.073a.5.5 0 01.733.442v1.986a.5.5 0 00.713.453l9.42-4.442a.5.5 0 01.704.342c.085.393.165 1.03.165 2.042M17.56 4.099a12.007 12.007 0 00-13.461 13.46c.673 5.349 4.993 9.668 10.34 10.342 7.85.99 14.452-5.612 13.462-13.462-.674-5.347-4.993-9.667-10.341-10.34'
        fill='currentColor'
        fillRule='evenodd'
      />
    </svg>
  )
}
